module.exports = __webpack_public_path__ + "img/car-moving.604f4b45.svg";